import React, { memo, useContext, useMemo } from 'react';

import { Tooltip } from 'antd';
import { getDateToBRPattern } from '@utils/formatters';
import { useTranslation } from 'react-i18next';

import { RiCalendarTodoFill } from 'react-icons/ri';
import SessionContext from '@providers/Session/SessionContext';
import CustomTag from '@components/CustomTag';

interface IBlockStatusTag {
  blockType: string;
  blockingInitialDate: string;
  blockingFinalDate: string;
}

const BlockStatusTag = ({
  blockType,
  blockingInitialDate,
  blockingFinalDate,
}: IBlockStatusTag) => {
  const { t } = useTranslation('inventory');
  const { theme } = useContext(SessionContext);

  const iconsStyles = {
    margin: 2,
    fontSize: 20,
    opacity: 0.5,
    color: theme?.colors?.green,
    cursor: 'pointer',
  };

  const showBlockingDates = useMemo(
    () =>
      !['0', '1', '5', 'NONE', 'TEMPORARY-SUSPENSION'].includes(blockType) &&
      (!['null', ''].includes(blockingInitialDate) ||
        !['null', ''].includes(blockingFinalDate)),
    [blockType, blockingInitialDate, blockingFinalDate],
  );

  const titleToolTip = useMemo(() => {
    let title = getDateToBRPattern(blockingInitialDate);
    // 3 = temporary
    if (
      blockType === '3' ||
      blockType === 'TEMPORARY' ||
      blockType === 'SUSPENSION' ||
      blockType === 'UNTIL_RENEWAL'
    ) {
      if (blockingFinalDate) {
        title += ` ${t('to')} ${getDateToBRPattern(blockingFinalDate)}`;
      }
    }

    return title;
  }, [blockType, t, blockingInitialDate, blockingFinalDate]);

  if (!blockType) {
    return <></>;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CustomTag
        color={blockType === '0' || blockType === 'NONE' ? 'green' : 'red'}
      >
        {t(`lock-status.types.${String(blockType)}`).toUpperCase()}
      </CustomTag>

      {showBlockingDates && (
        <Tooltip title={titleToolTip}>
          <RiCalendarTodoFill style={{ ...iconsStyles, fontSize: 18 }} />
        </Tooltip>
      )}
    </div>
  );
};

export default memo(BlockStatusTag);
